export const tr = {
    'request-error': 'Hata oluştu. Tekrar deneyin.'
};
